<template>
    <div class="account-data" v-loading="loading">
        <div class="account-data__content">
            <div class="account-data__block">
                <ModelCheckbox
                    v-model="profile.isNeverStudiedAtUniversity"
                    label="Никогда не учился в учебном заведении"
                />
            </div>
            <div v-if="!profile.isNeverStudiedAtUniversity">
                <div
                    v-for="(item, index) in getEducations"
                    class="account-data__item"
                    :key="index"
                >
                    <div class="delete-block">
                        <div class="delete-block__btn" @click="rmEdu(item, index)" data-voicetext="Удалить добавленный блок">
                            {{
                                isMobile
                                    ? 'Удалить блок'
                                    : 'Удалить добавленный блок'
                            }}<span>+</span>
                        </div>
                    </div>

                    <WideEduItem
                        :edu="item"
                        @change="changeEducationHandler($event, index)"
                    />
                </div>
            </div>
            <div
                class="add-block-btn"
                :class="[
                    { disabled: profile.isNeverStudiedAtUniversity },
                    { 'add-block-btn--mt': getEducations.length },
                ]"
                data-voicetext="Добавить уровень образования"
                @click="addEdu"
            >
                Добавить уровень образования
            </div>
        </div>
        <FixedSaveBtn
            v-if="showFixedSaveBtn"
            @close="closeFixedBtn"
        >
            <ActionButton
                @b-action="saveData"
                :b-color="saveButton.color"
                b-t-color="white"
                :b-text="saveButton.fixedText"
                class="save-block__btn--position save-block__btn"
            />
        </FixedSaveBtn>
        <div
            class="save-block"
        >
            <ActionButton
                ref="educationBtn"
                @b-action="saveData"
                :b-color="saveButton.color"
                b-t-color="white"
                :b-text="saveButton.text"
                class="save-block__btn--position save-block__btn"
            />
        </div>
    </div>
</template>

<script>
import WideEduItem from './WideEduItem';
import FixedSaveBtn from '../FixedSaveBtn';
import ActionButton from '../../../UI/inputs/ActionButton';
import ModelCheckbox from '../../../UI/models/ModelCheckbox';

import { mapGetters, mapMutations, mapActions } from 'vuex';
import moment from "moment";

const getters = ['getEducations', 'isMobile', 'userProfileInfo'];

const mutations = ['changeEducations'];

const actions = [
    'loadEducations',
    'addEducation',
    'updateEducation',
    'removeEducation',
    'postProfileData',
];

export default {
    name: 'WideEducationData',
    data: () => ({
        showFixedSaveBtn: false,
        observer: null,
        loading: false,
        profile: {
            isNeverStudiedAtUniversity: false,
        },
        saveButton: {
            fixedText: 'Сохранить изменения',
            text: 'Сохранить',
            color: '#4663AB',
            status: 'wait',
        },
    }),
    computed: {
        ...mapGetters(getters),
    },
    methods: {
        ...mapMutations(mutations),
        ...mapActions(actions),
        closeFixedBtn() {
            this.showFixedSaveBtn = false;
            this.observer ? this.observer.disconnect() : '';
        },
        async addEdu() {
            if (this.profile.isNeverStudiedAtUniversity) return;
            await this.addEducation();
        },

        async rmEdu(education, index) {
            await this.removeEducation({ education: education, index: index });
        },

        changeEducationHandler(item, index) {
            const educations = this.getEducations || [];
            const updatedEducations = educations.map((el, elIndex) =>
                elIndex === index ? item : el
            );
            this.changeEducations([...updatedEducations]);
        },

        async saveData() {
            if (this.saveButton.status != 'wait') return;
            this.saveButton.status = 'wait';
            this.saveButton.color = '#4663AB';
            this.saveButton.text = 'Сохранение...';
            this.saveButton.fixedText = 'Сохранение...';

            try {
                const promises = [];
                promises.push(
                    this.postProfileData({
                        isNeverStudiedAtUniversity: this.profile
                            .isNeverStudiedAtUniversity,
                    })
                );
                this.getEducations.forEach((edu, index) => {
                    if (edu.isNotUniversityFromCatalog !== null) {
                        if (edu.isNotUniversityFromCatalog) {
                            edu.foreignPlaceId = null;
                        } else {
                            edu.educationPlace = null;
                        }
                    }
                    if (edu.dateEnd) {
                      edu.dateEnd = moment(edu.dateEnd).endOf("month").format("YYYY-MM-DD");
                    }

                    promises.push(
                        this.updateEducation({ edu: edu, index: index })
                    );
                });
                await Promise.all(promises);
                this.saveButton.status = 'wait';
                this.saveButton.color = '#238C47';
                this.saveButton.text = 'Данные сохранены';
                this.saveButton.fixedText = 'Данные сохранены';
                this.showFixedSaveBtn = false;
                this.observer ? this.observer.disconnect() : '';

                setTimeout(() => {
                    this.saveButton.text = 'Сохранить';
                    this.saveButton.fixedText = 'Сохранить изменения';
                    this.saveButton.color = '#4663AB';
                }, 2000);
            } catch (e) {
                this.saveButton.status = 'wait';
                this.saveButton.color = '#F7E9F1';
                this.saveButton.text = 'Ошибка! извините..';
                this.saveButton.fixedText = 'Ошибка! извините..';

                setTimeout(() => {
                    this.saveButton.text = 'Сохранить';
                    this.saveButton.fixedText = 'Сохранить изменения';
                    this.saveButton.color = '#4663AB';
                }, 2000);
            }
        },
    },
    components: {
        WideEduItem,
        ActionButton,
        ModelCheckbox,
        FixedSaveBtn,
    },
    created() {
        const cb = key => {
            // TODO валидацию firstEdu и education
            if (this.profile.hasOwnProperty(key))
                this.profile[key] = this.userProfileInfo[key];
        };

        Object.keys(this.userProfileInfo).forEach(cb);
    },
    async mounted() {
        this.loading = true;
        await this.loadEducations();
        this.loading = false;
        this.observer = new IntersectionObserver((entries) => {
            entries.forEach( (entry) => {
                !entry.isIntersecting && Math.sign(entry.boundingClientRect.top) === 1 ? this.showFixedSaveBtn = true : this.showFixedSaveBtn = false;
            });
        });

        this.$watch('getEducations', () => {
            this.observer.observe(this.$refs.educationBtn.$el);
        }, {deep: true});
        this.$watch('profile', () => {
            this.observer.observe(this.$refs.educationBtn.$el);
        }, {deep: true});
    },
    beforeDestroy() {
        this.observer ? this.observer.disconnect() : '';
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/account-data.scss';

</style>
